import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@kmgestao/ui';

import { supabase } from '../../lib/supabase.js';

/**
 * Faz logout no Supabase, limpa o cache do TanStack Query e mostra toast.
 * O `onAuthStateChange` do `SessionProvider` dispara o redirect automático
 * quando acoplado a `<RequireAuth>`.
 */
export function useSignOut() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.clear();
      toast.success('Sessão encerrada');
    },
    onError: (error: Error) => {
      toast.error('Não foi possível encerrar a sessão', { description: error.message });
    },
  });
}
